import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Radio,
} from "@mui/material";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { MdOutlineClose } from "react-icons/md";
import moment from "moment";

import GetAppIcon from "@mui/icons-material/GetApp";

import { baseServiceUrl, urls } from "../../../environment";
import CustomAccordion from "../../../components/CustomAccordion";
import useUserStore from "../../../stores/useUserStores";
interface ScutinyQuestionAnswersProps {
  userResult: Array<any>;
  examResultDetails: any;
  selectedAnswerForReview: number | null;
  setSelectedAnswerForReview: Dispatch<SetStateAction<number | null>>;
  openRemarksModal: () => void;
}

const ScutinyQuestionAnswers = ({
  userResult,
  examResultDetails,
  selectedAnswerForReview,
  setSelectedAnswerForReview,
  openRemarksModal,
}: ScutinyQuestionAnswersProps) => {
  const userDetails = useUserStore();
  const [QuestionOpen, setQuestionOpen] = useState<boolean>(true);
  const [AnswersOpen, setAnswersOpen] = useState<boolean>(true);

  return (
    <div>
      <div className="w-[99.3%]">
        <div className="mb-3">
          <CustomAccordion
            setExpanded={setQuestionOpen}
            isExpanded={QuestionOpen}
            title={"Examination Marks"}
          >
            <div className=" rounded p-2 gap-y-2 grid grid-cols-12 gap-3 p-3">
              <div className="col-span-4">
                <p className="text-lg text-gray-600">Total Question</p>
                <p className="text-xl font-semibold">
                  {examResultDetails?.result_summary?.total_questions ?? "N/A"}
                </p>
              </div>
              <div className="col-span-4">
                <p className="text-lg text-gray-600">Total Marks</p>
                <p className="text-xl font-semibold">
                  {examResultDetails?.result_summary?.total_marks ?? "N/A"}
                </p>
              </div>
              <div className="col-span-4 lg:ml-[100px] ">
                <p className="text-lg text-gray-600">Marks Obtained</p>
                <p className="text-xl font-semibold">
                  {examResultDetails?.result_summary?.obtain_marks ?? "N/A"}
                </p>
              </div>
              <div className="col-span-4 ">
                <p className="text-lg text-gray-600">No. of Attempted</p>
                <p className="text-xl font-semibold">
                  {examResultDetails?.result_summary?.total_attempt ?? "N/A"}
                </p>
              </div>
              <div className="col-span-4 ">
                <p className="text-lg text-gray-600">No. of Not Attempted</p>
                <p className="text-xl font-semibold">
                  {examResultDetails?.result_summary?.not_attempted ?? "N/A"}
                </p>
              </div>
              <div className="col-span-4 lg:ml-[100px]">
                <p className="text-lg text-gray-600">Total Correct Answers</p>
                <p className="text-xl font-semibold">
                  {examResultDetails?.result_summary?.total_correct ?? "N/A"}
                </p>
              </div>
            </div>
          </CustomAccordion>
          <div className="mt-2">
            <CustomAccordion
              setExpanded={setAnswersOpen}
              isExpanded={AnswersOpen}
              title={"Choose Answers For Objection"}
            >
              <div
                className={`w-[99.3%]  mt-3 ${
                  QuestionOpen ? `max-h-[43vh]` : `max-h-[59vh]`
                }  overflow-y-auto overflow-x-hidden rounded-b-md px-5`}
              >
                {examResultDetails &&
                  examResultDetails.result_details &&
                  Array.isArray(examResultDetails.result_details) &&
                  examResultDetails.result_details.map((item: any) => (
                    <div
                      key={item.qid}
                      onClick={() => setSelectedAnswerForReview(item.id)}
                      className={`mb-4 flex  cursor-pointer p-4 border rounded-lg transition-transform transform  ${
                        item.marks < 0
                          ? " border border-transparent hover:border-red-500 bg-red-200/40 hover:bg-white bg-white"
                          : "border border-transparent hover:border-green-500 bg-green-200/40 hover:bg-white bg-white"
                      }`}
                    >
                      <p className="visibility-none opacity-0">{item?.id}</p>
                      <Radio
                        key={item.id}
                        value={selectedAnswerForReview}
                        checked={item.id === selectedAnswerForReview}
                        // checked={item.id === selectedAnswerForReview}
                      />
                      <div>
                        <p className="font-semibold">{item.question}</p>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: "2px",
                          }}
                        >
                          <p>
                            <span className="font-medium">Alloted Marks: </span>
                            {item.alloted_marks}
                          </p>
                          <p>
                            <span className="font-medium ml-5">
                              Negative Marks:{" "}
                            </span>
                            {item.negetive_mark}
                          </p>
                        </div>

                        <p className="mt-1">
                          <span className="font-medium">Selected Answer: </span>
                          {item.selected_options_value} {item.selected_answer}
                        </p>
                        <p className="mt-1">
                          <span className="font-medium">Correct Answer: </span>
                          {item.correct_answer_option}
                          {item.correct_answer}
                        </p>
                        <p
                          className={`mt-1 font-medium ${
                            item.marks < 0 ? "text-red-500" : "text-green-500"
                          }`}
                        >
                          Marks: {item.marks}
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            </CustomAccordion>
          </div>
          <div className="mt-4 flex items-center justify-center">
            <Button
              onClick={openRemarksModal}
              disabled={!selectedAnswerForReview || selectedAnswerForReview < 1}
              variant="contained"
            >
              Apply
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScutinyQuestionAnswers;
